/**
 * Componente sin output visual: cada vez que cambia el pathname
 * de React Router, hace scroll a la parte de arriba de la página.
 *
 * Solución al bug clásico de SPA: navegar de /dashboard/courses a
 * /courses/:slug preservaba la posición Y previa y abrea el curso
 * a la mitad de la página.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);
  return null;
}
